import { z } from 'zod';

export const loginSchema = z.object({
  username: z
    .string()
    .trim()
    .min(1, 'login.errors.usernameRequired')
    .max(64, 'login.errors.tooLong'),
  password: z
    .string()
    .trim()
    .min(1, 'login.errors.passwordRequired')
    .max(128, 'login.errors.tooLong'),
});

export type LoginValues = z.infer<typeof loginSchema>;
